/**
 *Created by jmmartinez on 04/03/2021
 * */

import React from 'react'
import PropTypes from 'prop-types';

import "../../resources/css/combobox.css";
import ComboBox from "../../blueprint/ComboBox";
import ClienteRestful from "../network/ClienteRestful";
import {servidor} from "../../../dental/Configuracion";



class ComboBoxImpresoras extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: props.id,
            valor: props.valor,
            itemSelected: {nombre: props.valor}
        }
    }

    componentDidMount() {
        this.loadImpresoras();
    }

    loadImpresoras= () => {
        let url= servidor + "completo/impresion/impresoras";
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doGet( response => {
            //console.log(response);
            this.setState({impresoras: response} );
        });
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.valor !== prevState.valor) {
            newState.valor = nextProps.valor;
            newState.itemSelected= {nombre: nextProps.valor}
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    onValueChanged= (objeto) => {
        const {onValueChanged} = this.props;
        this.setState({ itemSelected : objeto });
        onValueChanged && onValueChanged(objeto);
    }

    render() {
        const {id,  impresoras, itemSelected, valor, valorInicial} = this.state;
        return (
            <div>
            {   impresoras && impresoras.length > 0 &&
                <ComboBox
                    id= {id}
                    fieldText={"nombre"}
                    fieldKey={"nombre"}
                    items={impresoras}
                    onValueChanged={this.onValueChanged}
                    placeholder= {"Impresora seleccionada"}
                    filterable={false}
                    popoverClassName="popover"
                    itemSelected= {itemSelected}
                    icon="print"
                />
            }
            </div>
        );
    }
}


ComboBoxImpresoras.propTypes = {
    valor: PropTypes.string,
    obligatorio: PropTypes.bool,
    onValueChanged: PropTypes.func,
}

export default ComboBoxImpresoras;